import type {
  IDocumentNode,
  INodeDevice,
  PartialNode,
} from "@shared/common/node/type";
import type { IDataMap } from "@shared/common/types/data-source";
import type { NodeEventData } from "@shared/common/types/sdk";
import { noopFunction } from "@shared/common/utils/helper";
import { writable } from "svelte/store";

const defaultOnSendCollectEvent = async () => {
  // eslint-disable-next-line no-console
  console.warn("onSendCollectEvent is not set");
};

const createStore = () => {
  const state = {
    device: writable<Exclude<INodeDevice, "ALL"> | null>(null),
    nodeData: writable<PartialNode<IDocumentNode> | null>(null),
    dataMap: writable<IDataMap>({}),
    onSendCollectEvent: writable<(data: NodeEventData) => Promise<void>>(
      defaultOnSendCollectEvent
    ),
    onImpressionEvent:
      writable<(node: PartialNode<IDocumentNode>) => Promise<void>>(
        noopFunction
      ),
    childrenNodeData: writable<PartialNode<IDocumentNode>[] | null>(null),
    impressionEventStatusMap: writable<Map<string, boolean> | null>(
      new Map<string, boolean>(null)
    ),
    rootShown: writable<boolean>(false),
  };
  return {
    state,
    reset: () => {
      state.device.set(null);
      state.nodeData.set(null);
      state.dataMap.set({});
      state.onSendCollectEvent.set(defaultOnSendCollectEvent);
      state.childrenNodeData.set(null);
      state.onImpressionEvent.set(noopFunction);
      state.impressionEventStatusMap.set(new Map<string, boolean>(null));
      state.rootShown.set(false);
    },
  };
};

export type NodeStore = ReturnType<typeof createStore>;

export default createStore;
